<!--
 * @Author: zl
 * @Date: 2022-09-15 15:43:08
 * @LastEditTime: 2022-09-17 15:28:19
 * @LastEditors: zl
 * @Description: 
-->
<template>
	<div class='VisasAndClaimsed-layout'>
		<el-row class="mb30">
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">签 证 / 索 赔 单</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<template slot="extra">第 1 页（共3页）</template>
					<el-descriptions-item label="审计任务名称"
										  :span="2">{{ form.taskIdName }}</el-descriptions-item>
					<el-descriptions-item label="类型"
										  :span="2">
						{{ form.type == 0 ? '签证' : '索赔' }}
					</el-descriptions-item>
					<el-descriptions-item label="项目名称">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="建设单位">{{ form.consUnitName }}</el-descriptions-item>
					<el-descriptions-item label="标段名称">{{ form.packIdName }}</el-descriptions-item>
					<el-descriptions-item label="合同依据">{{ form.contractIdName }}</el-descriptions-item>
					<el-descriptions-item label="签证名称"
										  :span="2">{{ form.sname }}</el-descriptions-item>
					<el-descriptions-item label="发起单位">{{ form.sponUnitName }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.sponPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="对方单位">{{ form.oppoUnitName }}</el-descriptions-item>
					<el-descriptions-item label="项目负责人">{{ form.oppoPrincipal }}</el-descriptions-item>
					<el-descriptions-item label="签证/索赔事由"
										  :span="2">{{ form.causeName }}</el-descriptions-item>
					<el-descriptions-item label="发起日期"
										  :span="2">
						{{ form.initDate ? form.initDate.substr(0, 10) :'' }}
					</el-descriptions-item>
					<el-descriptions-item label="申请费用 (元)">{{ form.applyFee }}</el-descriptions-item>
					<el-descriptions-item label="申请工期 (日历天)">{{ form.schedule }}</el-descriptions-item>
					<el-descriptions-item label="批准费用 (元)">{{ form.ratifyFee }}</el-descriptions-item>
					<el-descriptions-item label="批准工期 (日历天)">{{ form.ratifySchedule }}</el-descriptions-item>
					<el-descriptions-item label="签证/索赔详情"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.details"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
			<el-col :span="22"
					:offset="1"
					class="text-right mt10">-1-</el-col>
		</el-row>
		<el-row class="mt20 mb30">
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">签 证 / 索 赔 单</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<template slot="extra">第 2 页（共3页）</template>
					<el-descriptions-item label="施工单位报审资料附件"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="1"
										 size="small"
										 border
										 style="margin: -2px"
										 class="custom-descriptions">
							<el-descriptions-item v-for="item in sgFileList"
												  :key="item.assortment + 'sg'"
												  :label="item.name"
												  labelClassName="w250">
								<div v-if="dealFileLength(item.assortment) > 0"
									 class="text-center blue-text"
									 @click="viewFile(item)">
									查看(共{{ dealFileLength(item.assortment) }}个文件)
								</div>
								<div v-else
									 class="text-center">-</div>
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
					<el-descriptions-item label="协审单位审计资料附件"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="1"
										 size="small"
										 border
										 style="margin: -2px"
										 class="custom-descriptions">
							<el-descriptions-item v-for="item in xsFileList"
												  :key="item.assortment + 'sg'"
												  :label="item.name"
												  labelClassName="w250">
								<div v-if="dealFileLength(item.assortment) > 0"
									 class="text-center blue-text"
									 @click="viewFile(item)">
									查看(共{{ dealFileLength(item.assortment) }}个文件)
								</div>
								<div v-else
									 class="text-center">-</div>
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
			<el-col :span="22"
					:offset="1"
					class="text-right mt10">-2-</el-col>
		</el-row>
		<el-row class="mt20">
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">签 证 / 索 赔 单</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions sp-descriptions">
					<template slot="extra">第 3 页（共3页）</template>
					<el-descriptions-item label="监理单位">{{ form.supUnit }}</el-descriptions-item>
					<el-descriptions-item label="签批意见">{{ form.supOpinion }}</el-descriptions-item>
					<el-descriptions-item label="签批人">{{ form.supSigner }}</el-descriptions-item>
					<el-descriptions-item label="签批日期">
						{{ form.supSignDate ? form.supSignDate.substr(0, 10) : '' }}
					</el-descriptions-item>

					<el-descriptions-item label="协审单位">{{ form.assUnitName }}</el-descriptions-item>
					<el-descriptions-item label="签批意见">{{ form.assOpinion }}</el-descriptions-item>
					<el-descriptions-item label="签批人">{{ form.assSigner }}</el-descriptions-item>
					<el-descriptions-item label="签批日期">
						{{ form.assSignDate ? form.assSignDate.substr(0, 10) : '' }}
					</el-descriptions-item>

					<el-descriptions-item label="建设单位">{{ form.consUnitName }}</el-descriptions-item>
					<el-descriptions-item label="签批意见">{{ form.consOpinion }}</el-descriptions-item>
					<el-descriptions-item label="签批人">{{ form.consSigner }}</el-descriptions-item>
					<el-descriptions-item label="签批日期">
						{{ form.consSignDate ? form.consSignDate.substr(0, 10) : '' }}
					</el-descriptions-item>

					<el-descriptions-item label="审计机关">{{ form.centerName }}</el-descriptions-item>
					<el-descriptions-item label="签批意见">{{ form.cenOpinion }}</el-descriptions-item>
					<el-descriptions-item label="签批人">{{ form.cenSigner }}</el-descriptions-item>
					<el-descriptions-item label="签批日期">
						{{ form.cenSignDate ? form.cenSignDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="备注"
										  :span="2"
										  contentClassName="h200">
						{{ form.remark }}
					</el-descriptions-item>
					<el-descriptions-item v-if="sgList.length > 0"
										  label="施工单位报审资料附件"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="1"
										 size="small"
										 border
										 style="margin: -2px"
										 class="custom-descriptions">
							<el-descriptions-item v-for="(item, index) in sgList"
												  :key="item.assortment + 'bottom'"
												  :label="dealName(item)"
												  contentClassName="w250">
								<template v-for="i in getFileList(item.assortment)">
									<FileName :fileName="i.fileName"
											  class="mr10"
											  :filePath="i.fileDirectory + i.fileName"></FileName>
								</template>
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
					<el-descriptions-item v-if="xsList.length > 0"
										  label="协审单位审计资料附件"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="1"
										 size="small"
										 border
										 style="margin: -2px"
										 class="custom-descriptions">
							<el-descriptions-item v-for="(item, index) in xsList"
												  :key="item.assortment + 'bottom'"
												  :label="dealName(item)"
												  contentClassName="w250">
								<template v-for="i in getFileList(item.assortment)">
									<FileName :fileName="i.fileName"
											  class="mr10"
											  :filePath="i.fileDirectory + i.fileName"></FileName>
								</template>
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
			<el-col :span="22"
					:offset="1"
					class="text-right mt10">-3-</el-col>
		</el-row>

		<!-- 上传弹窗 -->
		<el-dialog :title="uploadDia.title"
				   :visible.sync="uploadDia.show"
				   width="1000px"
				   append-to-body
				   :close-on-click-modal="false"
				   center
				   :destroy-on-close="true"
				   @closed="closeUpload">
			<myUpload list-type="table"
					  ref="test"
					  tableName="audit_visa"
					  :assortment="uploadObj.assortment"
					  :aid="form.id"
					  :isDisabled="true"
					  mode="view"
					  uploadType="2"></myUpload>
		</el-dialog>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {
				fileSummaryList: [],
			},
			sgList: [],
			xsList: [],
			uploadDia: {
				show: false,
			},
			uploadObj: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectAuditVisaDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data

				this.sgList = this.form.fileSummaryList.filter(
					(x) => x.assortment <= 7
				)
				this.sgFileList.forEach((x) => {
					let index = this.sgList.findIndex(
						(y) => x.assortment == y.assortment
					)
					if (index > -1) {
						this.sgList[index].show = true
					}
				})
				this.xsList = this.form.fileSummaryList.filter(
					(x) => x.assortment > 7
				)
				this.xsFileList.forEach((x) => {
					let index = this.xsList.findIndex(
						(y) => x.assortment == y.assortment
					)
					if (index > -1) {
						this.xsList[index].show = true
					}
				})
			})
		},

		// 查看文件
		viewFile(data) {
			this.uploadDia.show = true
			this.uploadObj = this.$utils.clone(data, true)
		},

		// 获取附件长度
		dealFileLength(data) {
			let arr = this.form.fileSummaryList.filter(
				(x) => x.assortment == data
			)
			return arr.length
		},

		//处理名字
		dealName(data) {
			let obj = {}
			if (parseInt(data.assortment) <= 7) {
				obj = this.sgFileList.find(
					(x) => x.assortment == data.assortment
				)
				return obj.name
			}
			obj = this.xsFileList.find((x) => x.assortment == data.assortment)
			return obj.name
		},

		// 获取附件
		getFileList(data) {
			let arr = this.form.fileSummaryList.filter(
				(x) => x.assortment == data
			)
			return arr
		},

		// 关闭弹窗
		closeUpload() {
			this.uploadDia.show = false
		},
	},
	computed: {
		sgFileList() {
			let arr = [
				{
					name: '签证单扫描件',
					assortment: '1',
				},
				{
					name: '签证报价文件',
					assortment: '2',
				},
				{
					name: '签证报价文件',
					assortment: '3',
				},
				{
					name: '签证报价文件',
					assortment: '4',
				},
				{
					name: '签证报价算量模型、工程计算书',
					assortment: '5',
				},
				{
					name: '签证事项施工前后照片',
					assortment: '6',
				},
				{
					name: '其他',
					assortment: '7',
				},
			]
			return arr
		},

		xsFileList() {
			let arr = [
				{
					name: '签证报价审核文件',
					assortment: '8',
				},
				{
					name: '签证报价审核文件',
					assortment: '9',
				},
				{
					name: '签证报价审核文件',
					assortment: '10',
				},
				{
					name: '签证报价算量模型、工程计算书',
					assortment: '11',
				},
				{
					name: '现场照片',
					assortment: '12',
				},
				{
					name: '其他',
					assortment: '13',
				},
			]
			return arr
		},
	},
}
</script>

<style lang='less' scoped>
</style>